export interface AirlinesQueryFilter {
  text: string | null;
  includeArchived: boolean;
  airlineRating: number | null;
  airlineStatus: number | null;
}
